<template>

    <div class="add_contacts_list_container">


        <div class="title_add_contact">
            <h3 class="title is-size-4 has-text-weight-bold ">
                {{ $t('components.shared.addContacts.contactListTitle', {contactLabel: contactLabel}) }}
            </h3>
        </div>
        <div class="add_contacts_list_items" v-if="contactList.length > 0">
            <transition-group name="list" tag="div">
                <div v-for="(contact, index) in contactList" :key="contact.email" class="add_contact_list_item_container" >
                    <div class="add_contact_list_item">
                        <div class="add_contact_list_item_info">
                            <span class="contact_username">{{contact.first_name}} {{contact.last_name}}</span><br>
                            <span class="contact_email">{{contact.email}}</span>
                        </div>
                        <div class="add_contact_list_item_delete" @click="sendRemoveEvent(contact, index)">
                            <i class="zmdi zmdi-close"></i>
                        </div>
                    </div>
                    <div class="files_container" v-if="allowFileUpload">

                        <div class="add_file_btn" v-if="clickUploadEnabled">
                            <span @click="openFileUpload(contact, index)">
                                {{ $t('components.shared.filesUpload.contactAddFileLink') }}
                            </span>
                        </div>
                        <div class="add_file_btn_disabled" v-else>
                            <span>
                                {{ $t('components.shared.filesUpload.contactAddFileLink') }}
                            </span>
                        </div>
                        <div class="contacts_files_list">
                            <div class="file_item" v-for="file, file_index in contact.docs_ids" :key="file.file_id">
                                <div class="file_item_name">
                                    {{ file.filename }}
                                </div>
                                <div class="file_item_delete" @click="removeFileItemFromContact(contact, index, file, file_index)">
                                    <i class="zmdi zmdi-close"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition-group>
        </div>
        <div class="add_contacts_list_items" v-else>
            {{ $t('components.shared.addContacts.contactListNotice', {contactLabel: contactLabel}) }}
        </div>

    </div>

</template>


<script>

export default {
    name: 'AddContactsList',
    props: {
        contactList: {
            required: true
        },
        contactLabel: {
            type: String,
            default: 'contact'
        },
        allowFileUpload: {
            type: Boolean,
            default: false
        },
        clickUploadEnabled: {
            required: true,
            type: Boolean,
            default: false
        },
    },
    methods: {
        sendRemoveEvent(contact, index){
            this.$emit('contactRemoved', index)
        },
        openFileUpload(contact, index){
            this.$emit('openFileUpload', contact, index)
        },
        removeFileItemFromContact(contact, index, file, file_index){
            this.$emit('removeFileItemFromContact', contact, index, file, file_index)
        }
    }
}
</script>

<style lang="scss" >
.add_contacts_list_container{
    padding: 12px;
}
.add_contacts_list_items{
    margin-top: 12px;
}
.add_contact_list_item_container{
    border-bottom: 1px solid $grey-lighter;
    padding-bottom: 12px;
    margin-bottom: 12px;
    .add_contact_list_item{
        display: flex;
        align-items: center;
        .add_contact_list_item_info{
            flex: 1;
            .contact_username{
                font-weight: 500;
            }
            .contact_email{
                font-weight: 600;
                color: $grey-light;
            }
        }
        .add_contact_list_item_delete{
            width: 32px;
            cursor: pointer;
            font-size: 2rem;
            color: $danger;
            text-align: center;
        }
    }
    .files_container{
        .add_file_btn{
            color: $info;
            cursor: pointer;
            &:hover{
                color: #3281b9;
            }
        }
        .add_file_btn_disabled{
            color: $dark;
            font-style: italic;
            opacity: 0.5;
        }
        .contacts_files_list{
            display: flex;
            flex-wrap: wrap;
            .file_item{
                background: white;
                border: 1px solid #d7dde6;
                margin: 2px;
                border-radius: 8px;
                display: flex;
                align-items: center;
                overflow: hidden;
                .file_item_name{
                    font-size: .75rem;
                    font-weight: 500;
                    padding: 2px 4px;
                    overflow: hidden;
                }
                .file_item_delete{
                    padding: 0px 6px 0px 5px;
                    border-left: 1px solid #d7dde6;
                    font-size: 1.1rem;
                    color: $danger;
                    background: $light;
                    transition: .1s all ease-in-out;
                    cursor: pointer;
                    &:hover{
                        color: $light;
                        background: $danger;
                    }
                }
            }

        }
    }
}
</style>